"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editorDataResolver = exports.IS_COMPONENT_PANEL_OPENED = exports.EXPERIMENT = exports.ENVIRONMENT = exports.COMPONENT_INSTANCE_DATA = exports.isEditorDataFunction = exports.editorDataFunction = exports.isComponentPanelOpened = exports.environment = exports.experiment = exports.componentInstanceData = void 0;
var COMPONENT_INSTANCE_DATA = 'component-instance-data';
exports.COMPONENT_INSTANCE_DATA = COMPONENT_INSTANCE_DATA;
var EXPERIMENT = 'experiment';
exports.EXPERIMENT = EXPERIMENT;
var ENVIRONMENT = 'environment';
exports.ENVIRONMENT = ENVIRONMENT;
var IS_COMPONENT_PANEL_OPENED = 'is-component-panel-opened';
exports.IS_COMPONENT_PANEL_OPENED = IS_COMPONENT_PANEL_OPENED;
function componentInstanceData(key) {
    return {
        type: COMPONENT_INSTANCE_DATA,
        key: key,
    };
}
exports.componentInstanceData = componentInstanceData;
function experiment(name) {
    return {
        type: EXPERIMENT,
        name: name,
    };
}
exports.experiment = experiment;
function environment(key) {
    return {
        type: ENVIRONMENT,
        key: key,
    };
}
exports.environment = environment;
function isComponentPanelOpened(key) {
    return {
        type: IS_COMPONENT_PANEL_OPENED,
        key: key,
    };
}
exports.isComponentPanelOpened = isComponentPanelOpened;
function editorDataFunction() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // NOTE: ...rest could be used only for last args
    // const [...paramResolvers, dataResolver] = args;
    var parameters = args.slice(0, args.length - 1);
    var dataResolver = args[args.length - 1];
    var f = function () {
        var paramValues = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            paramValues[_i] = arguments[_i];
        }
        return dataResolver.apply(void 0, paramValues);
    };
    f.parameters = parameters;
    return f;
}
exports.editorDataFunction = editorDataFunction;
function isEditorDataFunction(dataOrResolver) {
    return (typeof dataOrResolver === 'function' &&
        dataOrResolver.hasOwnProperty('parameters'));
}
exports.isEditorDataFunction = isEditorDataFunction;
// definition: https://github.com/wix-private/wix-ui-santa/blob/675f0906e2a4eee9136184143b9345d3f2c09014/src/editorUtils/editorDataResolver.js
// export: https://github.com/wix-private/wix-ui-santa/blob/00cbd2269b526a9c247451024b69508d0ccc8168/src/components-service/editor.js#L317-L326
// resolving: https://github.com/wix-private/santa-editor/blob/81c9633e70470232393a402723ae6be50f243e8b/santa-editor/packages/stateManagement/components/componentDataResolver.ts
exports.editorDataResolver = {
    componentInstanceData: componentInstanceData,
    experiment: experiment,
    environment: environment,
    isComponentPanelOpened: isComponentPanelOpened,
    editorDataFunction: editorDataFunction,
    isEditorDataFunction: isEditorDataFunction,
    COMPONENT_INSTANCE_DATA: COMPONENT_INSTANCE_DATA,
    ENVIRONMENT: ENVIRONMENT,
    EXPERIMENT: EXPERIMENT,
    IS_COMPONENT_PANEL_OPENED: IS_COMPONENT_PANEL_OPENED,
};
//# sourceMappingURL=index.js.map